import axios from 'axios';
import AuthenticationHelper from './authenticationHelper';
import { reportLogoutSuccess } from 'redux/auth/AuthActions';
import goToS1 from 'shared/helpers/redirectionHelper';

const setAxiosInterceptors = store => {
  axios.defaults.baseURL = `${window.location.protocol}//${window.location.host}/api/utm/v1`;

  axios.interceptors.request.use(config => {
    config.headers = AuthenticationHelper.getHeaders(config.url);
    return config;
  });

  axios.interceptors.response.use(resp => {
    if (resp.data.errMsg && resp.data.status === 401) {
      store.dispatch(reportLogoutSuccess());
      goToS1();
      return Promise.reject(resp);
    }

    if (resp.data.errMsg) return Promise.reject(resp);

    if (resp.config.url.includes('/otp-login')) {
      AuthenticationHelper.storeJwtToken(
        resp.headers['platform-token'] || resp.data
      );
    }
    else {
      AuthenticationHelper.storeJwtToken(resp.headers.authorization);
    }
    return resp;
  });
  
  axios.interceptors.response.use(undefined, err => {
    if (
      err.response &&
      ((err.response.status === 400 &&
        err.response.data.message === 'Authorization Error') ||
        (err.response.status === 401 &&
          err.response.data.message === 'Expired token'))
    ) {
      goToS1();
      store.dispatch(reportLogoutSuccess());
    }
    return Promise.reject(err.response);
  });
};

export { setAxiosInterceptors };



// WEBPACK FOOTER //
// ./src/shared/helpers/axiosInterceptors.js